import React, { Component } from 'react';
import ModifySearchContainer from './ModifySearchContainer';

class ModifySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      // <div className="flightsMf">
      <ModifySearchContainer {...this.props} />
      // </div>
    );
  }
}

export default ModifySearch;
